import { Directive } from '@angular/core';

@Directive({
  selector: '[customActionsLeft]'
})
export class CustomActionsLeftDirective { }
